module.exports = __webpack_public_path__ + "static/img/er_code_uniapp.f02c0a38.jpg";